<template>
    <div class="col-12">
        <div class="input-group mb-3">
            <input aria-describedby="basic-addon1" aria-label=""
                   class="form-control col-form-label-lg"
                   name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
            <div class="input-group-append">
              <button class="btn btn-primary" dusk="search_button" type="button" v-on:click="search(false)">
                {{ $t('search') }}
              </button>
            </div>
        </div>
      <small class="form-text text-muted">
        <i v-if="loading" class='fas fa-circle-notch fa-spin'></i> <span
          v-if="!loading">{{
          $t('number_of_result', {
            number: (response['total'] > 0) ? '1 - ' + response['to'] +
                '(total: ' + response['total'] + ')' : '0'
          })
        }}
    </span>
      </small>
        <div class="row mt-5">
            <div class="col-12 col-md-3">
              <h6 class="mt-3">{{ $t('equipments') }}:</h6>
                <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments">
                    <input :disabled="loading" class="custom-control-input" type="checkbox"
                           v-bind:checked="!badge['disabled']"
                           v-bind:id="index" v-bind:name="badge['id']" v-on:click="inverseBadge(index)"/>
                    <label class="custom-control-label" v-bind:for="index">
                        {{ badge['type']['name']}}, {{ badge['location'] }}
                    </label>
                </div>
            </div>
            <div class="col-12 col-md-9">
                <div class="row">
                  <p v-if="loading && page === 1">
                    <i class="fas fa-circle-notch fa-spin"></i> {{ $t('data_loading') }}
                  </p>
                    <p v-if="data.length === 0 && loading === false">
                      {{ $t('no_result_found') }}
                    </p>
                    <div class="col-12 col-md-6" v-for="entry in data">
                        <div class="card mb-3 bg-light">
                            <div class="row no-gutters">
                                <div class="col-md-4 image-cover"
                                     v-bind:style="'background-image: url(\'' + entry['cover_image_path'] + '\');background-size: contain; background-repeat: no-repeat;'">
                                </div>
                                <div class="col-md-8">
                                    <div class="card-body d-flex flex-column">
                                        <h5 class="card-title">{{ entry['title'] }}</h5>
                                        <p class="card-text">{{ entry['description'] }}</p>
                                        <p v-for="file in entry['documents']">
                                          <a class="btn btn-success mt-1" target="_blank"
                                             v-bind:href="'/data/' + file['file_path']">
                                            {{ $t('see') }} - {{ file['button_text'] }} <i
                                              class="fas fa-share-square"></i>
                                          </a>
                                        </p>
                                        <button class="btn btn-success disabled mt-auto" disabled type="button"
                                                v-if="entry['documents'].length === 0">
                                          {{ $t('no_file_available') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!loading && data.length !== 0 && response['last_page'] > page">
                      <span id="loadMore" v-on:click="loadMore">{{ $t('load_more') }}</span>
                    </p>
                  <p v-if="loading && data.length !== 0 && response['last_page'] > page">
                    <i class="fas fa-circle-notch fa-spin"></i> {{ $t('next_results_loading') }}
                  </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['equipments_id'],
        data: function () {
            return {
                page: 1,
                response: [],
                loading: true,
                query: '',
                data: [],
                equipments: [],
            }
        },
        filters: {
        },
        computed: {},
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted: function () {
            axios.post('equipments/json', {})
                .then(response => {
                    this.equipments = response.data;
                    this.equipments.forEach(function (item) {
                        if (this.equipments_id.length > 0) {
                            if (this.equipments_id.indexOf(item['id']) < 0) {
                                item['disabled'] = true;
                            } else {
                                item['disabled'] = false;
                            }
                        } else {
                            item['disabled'] = false;
                        }

                    }.bind(this));
                    this.search();
                });
        },
        methods: {
            handleScroll: function () {
                if (!this.loading) {
                    if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
                        this.loadMore();
                    }
                }
            },
            isInViewport: function (elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            loadMore: function () {
                this.page++;
                this.search(true);
            },
            inverseBadge: function (index) {
                this.equipments[index]['disabled'] = !this.equipments[index]['disabled'];
                this.$forceUpdate();
                this.search(false);
            },
            search: function (next_page = false) {
                this.loading = true;
                if (!next_page) {
                    this.page = 1;
                    this.data = [];
                }
                this.loading = true;
                var equipments_id = [];
                this.equipments.forEach(function (item) {
                    if (!item['disabled']) {
                        equipments_id.push(item['id']);
                    }
                });
                axios
                    .post('resources/search', {
                        query: this.query,
                        equipments: equipments_id,
                        page: this.page
                    })
                    .then(response => {
                        if (next_page) {
                            this.data = this.data.concat(response.data.data);
                        } else {
                            this.data = response.data.data;
                        }
                        this.response = response.data;
                        this.loading = false;
                    });

            },
        }
    }
</script>
